import { render, staticRenderFns } from "./VuesticMultiSelect.vue?vue&type=template&id=072db285&scoped=true"
import script from "./VuesticMultiSelect.vue?vue&type=script&lang=js"
export * from "./VuesticMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./VuesticMultiSelect.vue?vue&type=style&index=0&id=072db285&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072db285",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072db285')) {
      api.createRecord('072db285', component.options)
    } else {
      api.reload('072db285', component.options)
    }
    module.hot.accept("./VuesticMultiSelect.vue?vue&type=template&id=072db285&scoped=true", function () {
      api.rerender('072db285', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-multi-select/VuesticMultiSelect.vue"
export default component.exports